import React from "react";

class YtPlayer extends React.PureComponent {
    componentDidMount = () => {
        if (!window.YT) {
            const tag = document.createElement("script");
            tag.src =
                "https://website.phonepe.com/js/ytiframe-scripts/iframe_api.js";
            window.onYouTubeIframeAPIReady = this.loadYtPlayerVideo;
            const firstScriptTag = document.getElementsByTagName("script")[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        } else {
            this.loadYtPlayerVideo();
        }
    };

    loadYtPlayerVideo = () => {
        const { id } = this.props;
        this.player = new window.YT.Player(`ytPlayer-${id}`, {
            videoId: id,
            events: {
                onReady: this.onPlayerReady,
                onStateChange: event =>
                    this.onPlayerStateChange(event, this.player),
            },
        });
    };

    onPlayerReady = event => {
        event.target.stopVideo();
    };

    onPlayerStateChange = (event, player) => {
        if (window.YT && event.data === window.YT.PlayerState.ENDED) {
            player.stopVideo();
        }
    };

    closeYtVideo = () => {
        if (this.player) this.player.stopVideo();
    };

    playYtVideo = () => {
        if (this.player) this.player.playVideo();
    };

    render = () => {
        const { id } = this.props;
        return <div id={`ytPlayer-${id}`} />;
    };
}

export default YtPlayer;
